
import {UseUserInfo} from "../../hooks/UseToken";
import "./Logged.scss"

const Logged = () => {
    const UserInfo = UseUserInfo()
    const first_name = UserInfo.first_name;
    const last_name = UserInfo.last_name;

    return (
        <div className="Logged d-flex">
            <div className="avatar">
                {first_name && last_name && <span>
                    {first_name.charAt(0)}
                    {last_name.charAt(0)}
                </span>}

                {!first_name && !last_name && <span>
                    {UserInfo.role.name.slice(0, 2)}
                </span>}
            </div>
            <div className="user-info">
                {first_name && last_name && <div className="user-name">{first_name} {last_name}</div>}
                {!first_name && !last_name && <div className="user-name">{UserInfo.email}</div>}
                <div className="role-name">{UserInfo.role.name}</div>
            </div>
        </div>
    )
}

export default Logged;